import { render, staticRenderFns } from "./SustainabilityProcess.vue?vue&type=template&id=425a0dea&scoped=true&"
import script from "./SustainabilityProcess.vue?vue&type=script&lang=ts&"
export * from "./SustainabilityProcess.vue?vue&type=script&lang=ts&"
import style0 from "./SustainabilityProcess.vue?vue&type=style&index=0&id=425a0dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a0dea",
  null
  
)

export default component.exports